import { CHECKOUT_REDUCER_KEY } from '../../../../../constants/reducer.constants';

const getPaySecureSessionId = (state) =>
  state[CHECKOUT_REDUCER_KEY].getIn(['values', 'paySecureSessionId']);

const hasCardBeenTokenized = (state) =>
  state[CHECKOUT_REDUCER_KEY].getIn(['values', 'hasCardBeenTokenized']);

export { getPaySecureSessionId, hasCardBeenTokenized };
